import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=46c84472"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports